import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/api";
import { Target, Trophy } from "lucide-react";

export default function TargetTicker() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/stats/target-achievers").then((r) => setRows(r.data || [])).catch(() => {});
  }, []);
  if (!rows.length) return null;
  const items = [...rows, ...rows];
  return (
    <div className="rounded-2xl overflow-hidden border border-emerald-300/60 bg-gradient-to-l from-emerald-50 via-white to-amber-50 shadow-sm" data-testid="target-ticker" dir="rtl">
      <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-l from-emerald-500 to-emerald-600 text-white">
        <Target size={18} />
        <span className="font-head font-bold text-sm">مدارس حقّقت المستهدف 90% 🎯</span>
      </div>
      <div className="relative overflow-hidden py-3">
        <motion.div
          className="flex gap-10 whitespace-nowrap px-4"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration: Math.max(items.length * 7, 20), ease: "linear", repeat: Infinity }}
        >
          {items.map((b, i) => (
            <div key={i} className="flex items-center gap-2 shrink-0">
              <Trophy size={18} className="text-amber-500" />
              <span className="font-bold text-stone-800 text-sm">{b.school_name}</span>
              <span className="text-stone-300">•</span>
              <span className="text-sky-700 text-sm">{b.coordinator_name || "منسق التطوع"}</span>
              <span className="text-stone-300">•</span>
              <span className="text-emerald-700 text-sm font-medium">{b.rate}%</span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
